/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React from "react";
import {
  MdCheckBox,
  MdCheckBoxOutlineBlank,
  MdIndeterminateCheckBox,
} from "react-icons/md";
import { FaChevronRight, FaChevronDown } from "react-icons/fa";

const TreeCheckbox = ({ data, mark, onClick, dropClick, expend }) => {
  const handleClick = (el) => {
    let markedOption = [...mark];
    if (el === "all") {
      const allValues = data.children.flatMap((child) => child.value);
      const compareAll = markedOption.filter((value) =>
        allValues.includes(value)
      );
      const isExisted = allValues.every((value) => compareAll.includes(value));
      //
      if (!isExisted) {
        allValues.forEach((element) => {
          if (!markedOption.includes(element)) {
            markedOption.push(element);
          }
        });
      } else {
        markedOption = markedOption.filter(
          (value) => !allValues.includes(value)
        );
      }
    } else {
      // Not All
      const singleCheck = el.value.some((value) =>
        markedOption.includes(value)
      );
      if (singleCheck) {
        markedOption = markedOption.filter(
          (value) => !el.value.includes(value)
        );
      } else {
        markedOption = [...markedOption, ...el.value];
      }
    }
    onClick(markedOption);
  };

  const clickModel = () => {
    if (expend !== data.value || !expend) {
      dropClick(data.value);
    } else {
      dropClick("");
    }
  };

  const matchInfo = (check) => {
    const found = mark.some((v) => check.includes(v));
    const allValuesMatched = check.every((age) => mark.includes(age));

    if (allValuesMatched) {
      return <MdCheckBox className="custom-checkbox"/>;
    } else if (found) {
      return <MdIndeterminateCheckBox className="custom-checkbox"/>;
    } else {
      return <MdCheckBoxOutlineBlank className="custom-checkbox"/>;
    }
  };

  const checkIcons = () => {
    const result = [];
    for (const item of data.children) {
      for (const value of item.value) {
        result.push(value);
      }
    }
    return matchInfo(result);
  };

  return (
    <div className="custom-dropdown">
      <div className="custom-dropdown-toggle">
        <span onClick={clickModel} className="arrow-toggle">
          {expend === data.value ? <FaChevronDown /> : <FaChevronRight />}
        </span>
        <div onClick={() => handleClick("all")} className="group-inner">
          {checkIcons()} <h6>{data.label}</h6>
        </div>
      </div>
      {/* dropdown */}
      {expend === data.value && (
        <div className="custom-dropdown-menu show">
          {data.children.map((el, key) => (
            <div key={key} onClick={() => handleClick(el)}>
              <p>
                {matchInfo(el.value)} - {el.label}
              </p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TreeCheckbox;
